<template>
      <div class="requirementEdit">
        <v-breadcrumbs>
          <v-breadcrumbs-item :exact="true" :to="{ name: 'home', params: {} }"
            >Home</v-breadcrumbs-item
          >
          <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
          <v-breadcrumbs-item :exact="true" :to="{ name: 'requirement', params: {} }">
          Requirement
          </v-breadcrumbs-item>
          <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
          <v-breadcrumbs-item :to="{ name: 'requirementEdit', params:{id: id} }">
            Edit Requirement
          </v-breadcrumbs-item>
        </v-breadcrumbs>

        <v-card>
          <v-card-title>Edit Requirement</v-card-title>
          <v-card-text>
            <requirement-form :id="id"></requirement-form>
          </v-card-text>
        </v-card>
      </div>
    </template>

    <script>
    import RequirementForm from './RequirementForm.vue';

    export default {
      name: 'requirement',
      data () {
        return {
          id: null
        }
      },
      components: {
        RequirementForm
      },
      created () {
          this.id = this.$route.params.id;
          this.$emit("showParent", false);
      }
    }
    </script>
    